export default "__VITE_ASSET__qHM8khdf__"